/* Cookie Policy — short companion to the Privacy Policy. Most modern
   privacy regimes (CCPA, ePrivacy) expect a separate, plain-English
   cookie disclosure linked from every page. */
import { Link } from "react-router-dom";
import { Cookie, ArrowLeft } from "lucide-react";

export default function Cookies() {
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="legal-cookies">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <Link to="/" className="text-xs text-foreground/55 hover:text-foreground inline-flex items-center gap-1.5 mb-8">
          <ArrowLeft className="w-3 h-3"/>Back to verqo
        </Link>
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-xl bg-foreground text-accent grid place-items-center">
            <Cookie className="w-5 h-5"/>
          </div>
          <div className="text-[10px] mono uppercase tracking-[0.2em] text-foreground/55">Legal · verqo Wholesale OS</div>
        </div>
        <h1 className="display text-4xl tracking-tight mt-2">Cookie Policy</h1>
        <div className="text-[12px] text-foreground/55 mt-2">v1.0 · Effective May 1, 2026</div>

        <div className="mt-8 prose prose-sm max-w-none text-foreground/85 leading-relaxed">
          <p>
            We use cookies and similar technologies (localStorage, sessionStorage)
            sparingly. This page tells you what we set, why, and how to opt out.
          </p>

          <h2 className="display text-xl mt-8 mb-2">1. Strictly necessary</h2>
          <ul>
            <li><strong>access_token</strong> (HTTP-only secure cookie) — keeps you logged in. Cleared on logout.</li>
            <li><strong>token</strong> (localStorage) — same purpose, mirror for the SPA. Removed on logout.</li>
            <li><strong>app_mode_override</strong> (sessionStorage) — remembers if you're inside a /demo session.</li>
          </ul>
          <p>These are essential for the Platform to function. They are never used for advertising or sold to third parties.</p>

          <h2 className="display text-xl mt-8 mb-2">2. Analytics &amp; product</h2>
          <ul>
            <li><strong>PostHog</strong> — anonymised product analytics so we can see which features get used. We do not enable session recording or replay.</li>
            <li><strong>Sentry</strong> — error tracking. We strip PII fields before submission.</li>
          </ul>

          <h2 className="display text-xl mt-8 mb-2">3. Third-party / embedded</h2>
          <ul>
            <li><strong>Plaid Link</strong> — when you connect a bank, Plaid sets its own cookies inside its iframe. Governed by <a href="https://plaid.com/legal/" className="underline" target="_blank" rel="noreferrer">Plaid's Privacy Policy</a>.</li>
            <li><strong>Cloudflare</strong> — DDoS / WAF protection. Sets a `cf_clearance` cookie that's required for HTTP access; expires after the session.</li>
          </ul>

          <h2 className="display text-xl mt-8 mb-2">4. We do NOT use</h2>
          <ul>
            <li>Advertising cookies, conversion-tracking pixels, or remarketing tags from any ad network.</li>
            <li>Cross-site tracking that follows you to other websites.</li>
            <li>Cookies that sell or share your personal information (within the meaning of CCPA §1798.140).</li>
          </ul>

          <h2 className="display text-xl mt-8 mb-2">5. Your choices</h2>
          <p>
            You can clear all verqo cookies via your browser's developer tools
            or settings. Doing so will log you out. If you disable cookies
            entirely, verqo will not work — every authenticated route relies
            on the session cookie.
          </p>

          <p>
            For more about how we handle data overall, see our <Link to="/legal/privacy" className="underline">Privacy Policy</Link>.
          </p>
        </div>
      </div>
    </div>
  );
}
